<template>
  <div class="main login-page" v-show="pageReady">
    <div class="split-container">
      <!-- 左侧：品牌展示 (60%) -->
      <div class="left-panel">
        <div class="bg-overlay"></div>
        <div class="bg-gradient"></div>
        
        <div class="brand-content">
          <img src="/weiit_logo.png" class="brand-logo" alt="Weiit Logo" style="height: 48px; margin-bottom: 2rem;" />
          <h1 class="brand-title">
            国内领先的数字化零售SaaS开源方案商
          </h1>
          <p class="brand-desc">
            专为品牌电商、零售打造的数字化增长引擎
          </p>
          
          <div class="brand-stats">
            <div class="avatars">
               <div v-for="i in 4" :key="i" class="avatar-circle"></div>
            </div>
            <p class="stats-text">
              <span class="highlight">5000+</span> 开发者Star
            </p>
          </div>
        </div>
      </div>

      <!-- 右侧：注册/试用表单 (40%) -->
      <div class="right-panel">
        <div class="login-container trial-container">
          <div class="login-header">
            <h2 class="welcome-title">联系我们</h2>
            <p class="welcome-sub">完善信息后，您将获得专业数字化零售顾问提供详细解答</p>
          </div>

          <a-form-model :model="formModel" :rules="rulesRef" ref="ruleForm" class="login-form" layout="vertical">
            <a-form-model-item prop="companyName" class="form-item-mb">
              <a-input
                v-model="formModel.companyName"
                size="large"
                placeholder="请输入企业名称"
                :maxLength="11"
                autocomplete="off"
                class="custom-input"
              >
                 <a-icon slot="prefix" type="shop" />
              </a-input>
            </a-form-model-item>

            <a-form-model-item prop="name" class="form-item-mb">
               <a-input
                v-model="formModel.name"
                size="large"
                placeholder="请输入经营者名称"
                :maxLength="11"
                autocomplete="off"
                class="custom-input"
               >
                 <a-icon slot="prefix" type="user" />
               </a-input>
            </a-form-model-item>

            <a-form-model-item prop="idcard" class="form-item-mb">
               <a-input
                v-model="formModel.idcard"
                size="large"
                placeholder="请输入身份证号"
                :maxLength="18"
                autocomplete="off"
                class="custom-input"
               >
                 <a-icon slot="prefix" type="idcard" />
               </a-input>
            </a-form-model-item>

            <a-form-model-item prop="phone" class="form-item-mb">
               <a-input
                v-model="formModel.phone"
                size="large"
                placeholder="请输入联系电话"
                :maxLength="11"
                autocomplete="off"
                class="custom-input"
               >
                 <a-icon slot="prefix" type="mobile" />
               </a-input>
            </a-form-model-item>

            <div class="captcha-row">
                <a-form-model-item prop="captcha" class="flex-1 form-item-mb">
                  <a-input
                    v-model="formModel.captcha"
                    size="large"
                    placeholder="验证码"
                    :maxLength="4"
                    autocomplete="off"
                    class="custom-input"
                    @keyup.enter="submit"
                  >
                     <a-icon slot="prefix" type="safety-certificate" />
                  </a-input>
                </a-form-model-item>
                <div class="captcha-img" @click="getVerification">
                   <img v-if="randCodeImage" :src="randCodeImage" title="点击刷新验证码" style="width: 100%; height: 100%; object-fit: cover;" />
                   <img v-else src="../assets/checkcode.png" title="点击刷新验证码" style="width: 100%; height: 100%; object-fit: cover;" />
                </div>
            </div>

            <!-- Uploads -->
            <div class="upload-group">
                <a-form-model-item label="门店照片" prop="shopImg" class="form-item-mb">
                   <file-upload multiple v-model="formModel.shopImg" :options="{number: 1}" />
                </a-form-model-item>
                 <a-form-model-item label="营业执照" prop="shopYyzz" class="form-item-mb">
                   <file-upload multiple v-model="formModel.shopYyzz" :options="{number: 1}" />
                </a-form-model-item>
                 <a-form-model-item label="药品经营许可证" prop="shopPhoto" class="form-item-mb">
                   <file-upload multiple v-model="formModel.shopPhoto" :options="{number: 1}" />
                </a-form-model-item>
            </div>

            <!-- 错误信息提示区域 -->
            <div class="error-message-box" v-if="loginErrorMessage">
               <a-icon type="close-circle" theme="filled" /> {{ loginErrorMessage }}
            </div>

            <a-button
                size="large"
                type="primary"
                class="submit-btn"
                :loading="loading"
                @click="submit"
            >
                立即提交
                <a-icon type="arrow-right" />
            </a-button>

             <div class="back-login-link text-center" @click="handleWorklogin">
                <a>返回登录</a>
             </div>
          </a-form-model>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fileUpload from "./module/fileUpload.vue";

export default {
  name: "applyForTrial",
  components: {
    fileUpload
  },
  data() {
    return {
      currdatetime: "", //时间搓
      randCodeImage: "", //验证码
      loading: false,
      loginErrorMessage: "", // 错误提示信息

      formModel: {
        appCodes: "",
        name: "",
        phone: "",
        companyName: "",
        captcha: "",
        shopImg: "",
        shopYyzz: "",
        shopPhoto: "",
        idcard: "" 
      },
      rulesRef: {
        name: [{ required: true, message: "请输入经营者名称！", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系电话！", trigger: "blur" },
          { validator: this.handlePhoneCheck }
        ],
        companyName: [{ required: true, message: "请输入企业名称！", trigger: "blur" }],
        idcard: [{ required: true, message: "请输入身份证号！", trigger: "blur" }],
        shopImg: [{ required: true, message: "请输入门店照片！", trigger: "blur" }],
        shopYyzz: [{ required: true, message: "请输入营业执照！", trigger: "blur" }],
        shopPhoto: [{ required: true, message: "请输入药品经营许可证！", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码！", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.getVerification();
    setTimeout(() => {
      this.pageReady = true;
    }, 300);
  },
  methods: {
    handlePhoneCheck(rule, value, callback) {
      var reg = /^1[3456789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    },
    getVerification() {
      this.currdatetime = new Date().getTime();
      this.$axios
        .get(`${this.$api.randomImage}/${this.currdatetime}`)
        .then(({ success, result, message }) => {
          if (success) {
            this.randCodeImage = result;
          } else {
            this.$message.error(message);
          }
        });
    },
    submit() {
      if (this.loading) return;
      this.loginErrorMessage = "";

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true;
          let data = Object.assign(this.formModel, {
            checkKey: this.currdatetime
          });
          this.$axios
            .post(this.$api.addApplyForTrial, data)
            .then(({ success, result, message }) => {
              this.loading = false;
              if (success) {
                this.$message.success("提交成功！");
                this.handleWorklogin();
              } else {
                this.loginErrorMessage = message || "提交失败，请重试";
                this.getVerification();
              }
            })
            .catch(() => {
                this.loading = false;
                this.loginErrorMessage = "网络或服务器异常，请稍后重试";
                this.getVerification();
            });
        } else {
            this.loginErrorMessage = "请完善表单信息";
        }
      });
    },
    handleWorklogin() {
      this.$router.push("/login");
    }
  }
};
</script>

<style lang="less" scoped>
@import './error-style.less';
.login-page {
  width: 100%;
  height: 100vh;
  background: #fff;
  overflow: hidden;
}

.split-container {
  display: flex;
  width: 100%;
  height: 100%;
}

/* Left Panel */
.left-panel {
  display: none; 
  width: 60%;
  position: relative;
  background-color: #111827;
  overflow: hidden;

  .bg-overlay {
    position: absolute;
    inset: 0;
    background-image: url('https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2564&auto=format&fit=crop');
    background-size: cover;
    background-position: center;
    opacity: 0.4;
    mix-blend-mode: overlay;
  }
  
  .bg-gradient {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top right, #000000, transparent);
  }
  
  .brand-content {
    position: relative;
    z-index: 10;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10%;
    color: white;
  }
  
  .logo-box {
    width: 48px;
    height: 48px;
    background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
    
    .logo-icon {
      font-size: 24px;
      color: white;
    }
  }
  
  .brand-title {
    font-size: 3.5rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1.5rem;
    background: linear-gradient(to right, #fff, #94a3b8);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  
  .brand-desc {
    font-size: 1.125rem;
    color: #9ca3af;
    line-height: 1.6;
    margin-bottom: 3rem;
  }
  
  .brand-stats {
    display: flex;
    align-items: center;
    gap: 1rem;
    
    .avatars {
      display: flex;
      margin-left: 0.5rem;
      
      .avatar-circle {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #374151;
        border: 2px solid #111827;
        margin-left: -0.5rem;
      }
    }
    
    .stats-text {
      color: #9ca3af;
      font-size: 0.875rem;
      
      .highlight {
        color: white;
        font-weight: 600;
      }
    }
  }
}

/* Right Panel */
.right-panel {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start; // Start from top for scrolling
  justify-content: center;
  background: #fff;
  overflow-y: auto; 
  padding: 2rem 0; // Add padding top/bottom
}

.login-container {
  width: 100%;
  max-width: 440px; 
  padding: 2rem;
}

.login-header {
  margin-bottom: 2rem;
  
  .welcome-title {
    font-size: 1.875rem;
    font-weight: 700;
    color: #111827;
    margin-bottom: 0.5rem;
  }
  
  .welcome-sub {
    color: #6b7280;
    font-size: 0.875rem;
  }
}

.login-form {
  .custom-input {
    /deep/ .ant-input {
      height: 48px;
      background: #F9FAFB;
      border: 1px solid #E5E7EB;
      border-radius: 8px;
      color: #111827;
      transition: all 0.2s;
      
      &:hover, &:focus {
        border-color: #4F46E5;
        background: #fff;
        box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.1);
      }
    }
    
    /deep/ .ant-input-prefix {
      color: #9CA3AF;
    }
  }

  .form-item-mb {
      margin-bottom: 16px;
  }

  .upload-group {
      margin-bottom: 1rem;
      
      /deep/ .file-upload {
          --upload-width: 100%;
          --upload-height: 120px;
          width: 100%;
      }
  }
}

.captcha-row {
  display: flex;
  gap: 1rem;
  
  .captcha-img {
    width: 120px;
    height: 48px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #E5E7EB;
    
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.submit-btn {
  width: 100%;
  height: 48px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
  
  &:hover {
    opacity: 0.9;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  }
}

.back-login-link {
    cursor: pointer;
    color: #4F46E5;
    font-weight: 500;
    &:hover {
        text-decoration: underline;
    }
}

.text-center {
    text-align: center;
    margin-top: 16px;
}

@media (min-width: 1024px) {
  .left-panel {
    display: block;
  }
  .right-panel {
    width: 40%;
    align-items: center; // Center vertically on large screens if content fits, or just stick to flex-start + auto margins if tall
  }
  // If content is tall, we might want to keep align-items: flex-start and use margin-auto
}
</style>
